<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    :style="{'--icon-stroke-width': strokeWidth}"
  >
    <path d="M14.4375 8.15L6.5625 3.6875" stroke-linecap="round" stroke-linejoin="round"/>
    <path
      d="M18.375 13.9982V6.99821C18.3747 6.69132 18.2937 6.38991 18.1401 6.12422C17.9865 5.85853 17.7658 5.6379 17.5 5.48446L11.375 1.98446C11.109 1.83086 10.8072 1.75 10.5 1.75C10.1928 1.75 9.89103 1.83086 9.625 1.98446L3.5 5.48446C3.23423 5.6379 3.01348 5.85853 2.8599 6.12422C2.70632 6.38991 2.62531 6.69132 2.625 6.99821V13.9982C2.62531 14.3051 2.70632 14.6065 2.8599 14.8722C3.01348 15.1379 3.23423 15.3585 3.5 15.512L9.625 19.012C9.89103 19.1656 10.1928 19.2464 10.5 19.2464C10.8072 19.2464 11.109 19.1656 11.375 19.012L17.5 15.512C17.7658 15.3585 17.9865 15.1379 18.1401 14.8722C18.2937 14.6065 18.3747 14.3051 18.375 13.9982Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M2.85938 6.09375L10.4981 10.5125L18.1369 6.09375" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 19.25V10.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BoxIcon',
  props: {
    strokeWidth: {
      type: String,
      default: '1.5'
    }
  }
}
</script>
